const s = {
  name: "Number4Circle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M22,19v-5h2v12h-2v-5h-6v-1h0v-6h2v5H22z"/>
<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20S31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18s-8.1,18-18,18
	S2,29.9,2,20z"/>
</svg>
  `
};
export {
  s as Number4Circle
};
